import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, of, retry } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { reqUploadFile } from '../../onerous/interfaces/new-vehicle/new-vehicle.interface';

import { getSessionId } from '../../../helpers/storageUtils';
import { UtilsService } from '../../../services/utils.service';
import { TokenService } from '../token.service';

@Injectable({
  providedIn: 'root',
})
export class UploadFileService {
  baseUrl = environment.URL_UPLOADFILES;

  private tokenService = inject(TokenService);
  token = this.tokenService.getToken();

  private http = inject(HttpClient);

  SESSION_ID = getSessionId().toString();
  private utils = inject(UtilsService);

  public uploadFiles(body: reqUploadFile): Observable<unknown> {
    const url = this.baseUrl;

    const headers = this.utils.getHeaders(this.SESSION_ID);

    return this.http.post<unknown>(url, body, { headers }).pipe(
      retry(2),
      catchError((error) => {
        console.error('Failed request for uploadFiles:', error);
        return of(null); // Retornar null en caso de error para permitir que el flujo continúe
      }),
    );
  }
}
